<template>
  <a-dropdown
    :trigger="['click']"
    :disabled="disabled || loading"
    placement="bottomRight"
    overlay-class-name="freight-table-actions-menu"
  >
    <a-button class="freight-table-actions-menu__btn" :loading="loading">
      Ações <a-icon type="down" />
    </a-button>

    <a-menu slot="overlay" @click="(info) => $emit('select', info.key)">
      <a-menu-item
        v-for="item in items"
        :key="item.key"
        :disabled="!!item.disabled"
        :class="item.danger ? 'freight-table-actions-menu__item--danger' : ''"
      >
        <a-icon :type="item.icon" /> {{ item.label }}
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
export default {
  name: "FreightTableActionsMenu",
  props: {
    items: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.freight-table-actions-menu__btn {
  border-radius: 6px;
  height: 36px;
  color: @color-text-medium;
}
</style>

<style lang="less">
@import "~@/shared/styles/variables.less";

.freight-table-actions-menu {
  .ant-dropdown-menu-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    font-size: 14px;
    color: @color-text-dark;

    .anticon {
      color: @color-text-medium;
    }
  }

  .freight-table-actions-menu__item--danger:not(
      .ant-dropdown-menu-item-disabled
    ) {
    color: @color-danger;

    .anticon {
      color: @color-danger;
    }
  }
}
</style>
